var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { COLORS, FONT, MARGIN } from '../../constants';
import { facepaintMediaQueries } from '../shared';
export var circle = {
  alignItems: 'center',
  borderRadius: '50%',
  borderStyle: 'solid',
  borderWidth: '2px',
  borderColor: COLORS.blues.primary,
  display: 'inline-flex',
  justifyContent: 'center',
  height: '24px',
  marginRight: '8px',
  width: '24px'
};
export var number = {
  fontSize: '11px',
  fontWeight: FONT.weight.regular,
  borderColor: COLORS.grays.light,
  backgroundColor: COLORS.white,
  color: COLORS.grays.light
};
export var item = __assign(__assign({
  alignItems: 'center',
  height: 24,
  display: 'inline-flex',
  color: COLORS.grays.darkest,
  flexDirection: 'row'
}, FONT.sizes.regular), {
  fontWeight: FONT.weight.bold,
  marginRight: MARGIN.big,
  '&:last-of-type': {
    marginRight: '0'
  }
});
export var activeItem = facepaintMediaQueries({
  fontSize: [FONT.sizes.h5.fontSize, FONT.sizes.h5.fontSize, FONT.sizes.regular.fontSize],
  lineHeight: [FONT.sizes.h5.lineHeight, FONT.sizes.h5.lineHeight, FONT.sizes.regular.lineHeight]
});
export var awaitingItem = facepaintMediaQueries({
  color: COLORS.grays.light,
  display: ['none', 'none', 'inline-flex']
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Stepper/item.styles.js
// module id = 1238
// module chunks = 0